import { useState, useEffect } from "react";
import { getApiUrl } from "../../utils/apiUrl";

const useFetchCsrfToken = () => {
  const [csrfToken, setCsrfToken] = useState("");

  useEffect(() => {
    const fetchCSRFToken = async () => {
      try {
        const response = await fetch(
          getApiUrl("api/csrf_token/"),
          {
            credentials: "include",
          },
        );
        const data = await response.json();
        setCsrfToken(data.csrfToken);
      } catch (error) {
        console.error("Error fetching CSRF token:", error);
      }
    };

    fetchCSRFToken();
  }, []); // Fetch only once on mount

  return csrfToken;
};

export default useFetchCsrfToken;
